<template>
    <div class="row">
        <div class="col-6">
            <label>Ano</label>
            <vue-multiselect 
                v-model="dadosSelecionados.ano"
                :options="listas.anos"
                placeholder="Ano"
                select-label=""
                selected-label=""
                deselect-label=""
                :multiple="false"
                :close-on-select="true"
                :clear-on-select="false"
                :preserve-search="true"
                :preselect-first="false"
                :allow-empty="false"
                @input="montarObjetoData">
                <span slot="noResult">Nenhum registro encontrado.</span>
                <span slot="noOptions">Selecione o Ano</span>
            </vue-multiselect>
        </div>
        <div class="col-6">
            <label>Mês</label>
            <vue-multiselect 
                v-model="dadosSelecionados.mes"
                :options="listas.meses"
                placeholder="Mês"
                select-label=""
                selected-label=""
                deselect-label=""
                :multiple="false"
                :close-on-select="true"
                :clear-on-select="false"
                :preserve-search="true"
                :preselect-first="false"
                :allow-empty="false"
                label="Nome"
                track-by="Id"
                @input="montarObjetoData">
                <span slot="noResult">Nenhum registro encontrado.</span>
                <span slot="noOptions">Selecione o Mês</span>
            </vue-multiselect>
        </div>
    </div>
</template>

<script>
export default {
    name: "AnoMes",
    data: function() {
        return {
            dadosSelecionados: {
                ano: new Date().getFullYear(),
                mes: new Date().getMonth() + 1,
            },
            listas: {
                anos: [],
                meses: []
            }
        }
    },
    mounted: function() {
        this.preencherListaAno();
        this.preencherListaMeses();
        this.montarObjetoData();
    },

    methods: {
        preencherListaAno: function() {
            var maximo = new Date().getFullYear();
            var minimo = maximo - 20;

            for (let i = minimo; i <= maximo; i++) {
                this.listas.anos.push(i);   
            }
        },
        preencherListaMeses: function() {
            var month = ["Janeiro", "Fevereiro", "Março", "Abril", "Maio", "Junho", "Julho", "Agosto", "Setembro", "Outubro", "Novembro", "Dezembro"];

            for (let i = 0; i < 12; i++) {
                this.listas.meses.push({
                    "Nome": month[i],
                    "Id": i
                });
            }

            this.dadosSelecionados.mes = this.listas.meses.filter(e => e.Id == new Date().getMonth())[0];
        },
        montarObjetoData: function () {
            var mes = this.dadosSelecionados.mes.Id;
            var ano = this.dadosSelecionados.ano;

            var rangeData = {
                dataInicial: new Date(ano, mes, 1),
                dataFinal: new Date(ano, mes+1, 0)
            }
            
            this.$emit('input', rangeData);
        }
    }
}
</script>